/* eslint-disable max-len */
import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IZadostResp, nzBankidApi } from 'services/nezarazenyUcet/nuZapis';

interface IPLZAPL {
    zadostData?: IZadostResp;
}

const PLZAPL: React.FC<IPLZAPL> = props => {
    const history = useHistory();
    const { zadostData } = props;
    const [errStatus, setErrStatus] = useState<number>();
    const { token } = useParams<{ token: string }>(); // Bank ID token sebran z urlky

    const routeChange = () => {
        let path = zadostData?.zadostid
            ? '/nezarazeny-ucet-zapis/idzadost/' + zadostData.zadostid
            : '/nezarazeny-ucet-zapis/idzadost/';
        history.push(path);
    };

    const onClick = () => {
        zadostData?.zadostid
            ? nzBankidApi(zadostData?.zadostid, token)
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  .then((resp: any) => {
                      window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID
                  })
                  .catch((err: AxiosError) => {
                      setErrStatus(err.response?.status);
                  })
            : setErrStatus(500);
    };

    return (
        <>
            {errStatus ? (
                <Col span={24}>
                    <Row>
                        {errStatus === 400 ? (
                            <Title text="RESPONSE_ERROR_400" level={3} />
                        ) : errStatus === 401 ? (
                            <Title text="RESPONSE_ERROR_401" level={3} />
                        ) : errStatus === 404 ? (
                            <Title text="RESPONSE_ERROR_404" level={3} />
                        ) : errStatus === 500 ? (
                            <Title text="RESPONSE_ERROR_500" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Row>

                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                    </Row>
                </Col>
            ) : (
                <>
                    <Row>
                        <h1>
                            <TranslateText>Úspěšná platba – pokračujte</TranslateText>
                        </h1>
                    </Row>
                    <Row>
                        <Paragraph
                            text="Platba proběhla úspěšně. Pokračujte přihlášením přes Bank iD a poskytněte osobní údaje nezbytné k provedení služby, včetně údaje o Vašem rodném čísle. Po provedení identifikace prostřednictvím Bank iD budete vyzváni k zadání čísla nezařazeného účtu, které si předem připravte. Pokud žádost nedokončíte a neposkytnete údaje potřebné k vyřízení žádosti, změna údajů v nezařazené evidenci nebude provedena. Dokončit žádost můžete ve lhůtě 14 dní od zaplacení, v případě nedokončené žádosti se platba nevrací."
                            style={{
                                marginBottom: 16
                            }}
                        />
                    </Row>
                    <Row className="statement-buttons-row">
                        <ButtonComponent buttontext="PRIHLASIT_SE_PPRES_BANKID" onClick={onClick} />
                    </Row>
                </>
            )}
        </>
    );
};

export default PLZAPL;
